<div class="flex flex-col items-start">
  <!-- Price -->
  @if (!listing().pending) {
    <p class="font-header text-4xl leading-none text-primary-500 dark:text-white/70 pb-1">
      {{ listing().price | currency: 'USD' : 'symbol' : '1.0-0' }}
    </p>
  }

  <!-- Address -->
  <button class="cursor-pointer" (click)="navPostMessage()">
    <h1>{{ listing().address.streetAddress }}</h1>
  </button>

  <!-- Series and model -->
  @if (listing().saleType !== 'homesite') {
    <div class="flex items-center gap-2">
      <span [style.color]="" class="truncate dark:text-gray-100!">
        @if (listing().series?.id !== 'manufactured') {
          <span>{{ listing().series?.title ?? '' | removeTrailingS }}: </span>
        }
        <span>{{ listing().model?.displayTitle }}</span>
      </span>
    </div>
  }

  <app-listing-details-features class="block lg:hidden" [listing]="listing()" />

  <!-- Village -->
  @if (stateService.community() === 'villages') {
    @if (listing().village.id === 'middleton') {
      <a href="https://mymiddleton.com/homefinder/" target="_blank" class="underline">{{
        listing().village.displayTitle
      }}</a>
    } @else {
      <p>{{ listing().village.displayTitle }}</p>
    }
  }
</div>
